import React from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import isEmpty from 'lodash/isEmpty';
import Validator from 'validator';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';
import Tooltip from '@material-ui/core/Tooltip';
import Amplify, { Auth } from 'aws-amplify';
import scrollToComponent from 'react-scroll-to-component';
import MaskInputNumber from '../common/maskInputNumber';
import * as SecretKeys from '../../ENV.json';
import {
  saveConsumerUser, GetAllAffiliateUsersByAffiliateType, saveBusinessUserStep1, getAllCountry, getPageData, checkEmailVerify, getAllStates, getAllPlansConsumer, confirmUserEmail, getBusiness, getIndustry, requestApiData,
} from '../../Actions/actions';
import TextFieldGroup from '../common/TextFieldGroup';
import TermAndCondition from '../common/termsAndCondition';
import SignatureComponent from '../common/signatureComponent';


Amplify.configure(SecretKeys.awsUserpool);

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cFirstName: '',
      cLastName: '',
      cState: '',
      cSince: '',
      cEmployer: '',
      cEmail: '',
      email: '',
      cPhone: '',
      cPassword: '',
      passwordType: 'password',
      cNotification: '0',
      cUpdateClaim: '0',
      errors: {},
      cognitoClientId: '',
      bankruptcyStatus: '',
      dissolvedStatus: '',
      acceptCC: '',
      isLoading: false,
      businessTypeId: '',
      cRoleName: 'Consumer',
      IsConusmerForm: 1,
      defaultIndexSign: 1,
      readDisclaimer: '',
      readPrivacyPolicy: '',
      readLetterOfAgency: '',
      readUserAgreement: '',
      errorsCompany: {},
      errorsTermPolicy: {},
      modalIsOpen: false,
      fileError: false,
      totalTaxId: '',
      file: '',
      code: '',
      signatureImageContentType: 'image/png',
      signatureImageFileSize: '',
      indicatorConsumer: '',
      affiliateId: '',
      caffiliateId: '',
      caffiliateKey: '',
      cCountryCode: '+1',
      phoneValue: '',
      planId: 23,
      bankAccount: '0',
      serviceFeeAgree: '0',
      isLoginCheck: false,
      cpasswordColor: 'black',
      changeSignature: 0,
      signatureDefaultValue: '',
      signatureFontFamily: '',
      emptyErrorSign: 1,
      intervalId: 0,
      pageType: 'consumer',
      enableButtonT: true,
      userDataLogin: [],
      BusinessUserDataStep1Data: {},


    };

    // console.log("showTab",this.props.showTab);
    if (this.props.partnerType === 'Consumer') {
      this.state.affiliateId = this.props.affiliateId;
      this.state.indicatorConsumer = <li className="indicator" />;
      this.state.IsConusmerForm = 5;
      this.state.cEmail = this.props.email;
    }
    this.handleSubmitConsumer = this.handleSubmitConsumer.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChange1 = this.onChange1.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this._cSelect = this._cSelect.bind(this);
    this._cSince = this._cSince.bind(this);
    this._onSelectForBusiness = this._onSelectForBusiness.bind(this);
    this._onSelectForYears = this._onSelectForYears.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.viewPassword = this.viewPassword.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this._cCountrySelect = this._cCountrySelect.bind(this);
    this.codeOnSubmit = this.codeOnSubmit.bind(this);
    this.finalSubmit = this.finalSubmit.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.backClick = this.backClick.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this._onSelectForPartner = this._onSelectForPartner.bind(this);

  }

  _onSelectForPartner(e) {
    this.setState({ caffiliateId: e.value }, () => {
    });

  }


  backClick() {
    this.setState(state => ({
      IsConusmerForm: state.IsConusmerForm - 1,
    }));
    window.scrollTo(0, 0);
  }

  handleSaveData = (langValue) => {
    this.setState({
      readDisclaimer: langValue.readDisclaimer,
      readPrivacyPolicy: langValue.readPrivacyPolicy,
      readLetterOfAgency: langValue.readLetterOfAgency,
      readUserAgreement: langValue.readUserAgreement,
      IsConusmerForm: 3,

    });
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId });
  }

  componentWillReceiveProps(nextProps) {
    const { RecieveConsumerUserData } = nextProps.data;
    if (typeof RecieveConsumerUserData !== 'undefined') {
      this.AfterLogin();
    }
  }


  onPlanSelectBar(id) {
    // console.log('id',id)
    this.setState({
      planId: id,
    });
    this.onPlanSelectSubmit();
  }

  componentDidMount() {
    const { GetAllAffiliateUsersByAffiliateType } = this.props
    GetAllAffiliateUsersByAffiliateType("Consumer")
  }

  componentWillMount() {
    this.setState({
      caffiliateKey: this.props.match.params.affiliateKey,
    });
    localStorage.setItem('consumerTab', '1');

    const dataB = {
      lookupTypeId: 1,
    };
    const dataI = {
      lookupTypeId: 1,
    };
    this.props.getPageData(6);
    this.props.getAllStates();
    this.props.getAllCountry();
    this.props.getAllPlansConsumer({
      pageNumber: 0, pageSize: 20, searchKeyword: '', planUserType: 'Consumer', userId: 0, affiliateKey: '',
    });
    this.props.getBusiness(dataB);
    this.props.getIndustry(dataI);
  }

  onPlanSelect(e) {
    const id = e.value;
    this.setState({
      planId: id,
    });
  }

  onPlanSelectSubmit() {
    if (this.props.partnerType === 'Consumer') {
      this.setState({
        IsConusmerForm: 1,
      });
    } else {
      this.setState({
        IsConusmerForm: 2,
        // signatureDefaultValue: this.state.cFirstName,
      });
    }
  }

  _cCountrySelect(e) {
    this.setState({ cCountryCode: e.value });
  }

  finalSubmit = async (data) => {
    this.setState({
      file: data.file,
    }, () => {
      const data1 = this.state;
      this.setState({ errors: {}, isLoading: true });
      this.props.saveConsumerUser(data1);
    });
  }


  _onSelect(e) {
    this.setState({ state: e.value, errors: {} });
  }

  _cSelect(e) {
    this.setState({ cState: e.target.value, errors: {} });
  }

  _cSince(e) {
    this.setState({ cSince: e.value, errors: {} });
  }


  _onSelectForBusiness(e) {
    this.setState({ businessTypeId: e.value });
  }

  _onSelectForYears(e) {
    this.setState({ industryTypeId: e.value });
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value, errors: {}, errorsTermPolicy: {}, errorsCompany: {},
    });
    this.setState({ cpasswordColor: 'black' });
    this.setState({ [e.target.name]: e.target.value }, () => { if (this.state.cEmail !== '') { this.props.checkEmailVerify({ email: this.state.cEmail }); } });

    if (e.target.name === 'email') {
      // let email = e.target.value;
      // Auth.userExist();
    }
  }

  verifyEmail() {
    if (this.state.cEmail !== '') {
      this.props.checkEmailVerify({ email: this.state.cEmail });
    }
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  isValidConsumer() {
    const { errors, isValidConsumer } = this.validateInputConsumer(this.state);

    if (!isValidConsumer) {
      this.setState({ errors });
    }
    return isValidConsumer;
  }

  validateInputConsumer(data) {
    const errors = {};
    const scrollViews = [];

    if (!data.cFirstName) {
      errors.cFirstName = 'First name is Required';
      errors.cFirstNameError = true;
      scrollViews.push(this.cFirstNameRef);
    } else if (data.cFirstName.length < 2) {
      errors.cFirstName = 'Please enter at least 2 characters';
      errors.cFirstNameError = true;
      scrollViews.push(this.cFirstNameRef);
    }

    if (!data.cLastName) {
      errors.cLastName = 'Last name is Required';
      errors.cLastNameError = true;
      scrollViews.push(this.cLastNameRef);
    } else if (data.cLastName.length < 2) {
      errors.cLastName = 'Please enter at least 2 characters';
      errors.cLastNameError = true;
      scrollViews.push(this.cLastNameRef);
    }

    if (data.cEmail !== '') {
      const isemailVerified = this.props.data.emailVerifyData;
      if (Object.keys(isemailVerified).length > 0) {
        if (isemailVerified.collectMessage.messageShort === 'User email already exist') {
          // errors.cEmail = 'This user\'s email address has already been added to Collectively';
          errors.cEmail = 'Email address already exists'
          scrollViews.push(this.cEmailRef);
        }
      }
    }

    if (!Validator.isEmail(data.cEmail)) {
      errors.cEmail = 'Email is Not Valid';
      errors.cEmailError = true;
      scrollViews.push(this.cEmailRef);
    }
    if (Validator.isEmpty(data.cEmail)) {
      errors.cEmail = 'Email is Required';
      errors.cEmailError = true;
      scrollViews.push(this.cEmailRef);
    }
    if (Validator.isEmpty(data.bankAccount) || data.bankAccount === '0') {
      errors.bankAccount = 'Required';
      errors.bankAccountError = true;
      scrollViews.push(this.bankAccountErrorRef);
    }

    // if (Validator.isEmpty(data.cNotification) || data.cNotification === '0') {
    //   errors.cNotification = 'Required';
    //   errors.cNotificationError = true;
    // }


    if (Validator.isEmpty(data.serviceFeeAgree) || data.serviceFeeAgree === '0') {
      errors.serviceFeeAgree = 'Required';
      errors.serviceFeeAgreeError = true;
      scrollViews.push(this.serviceFeeAgreeRef);
    }
    if (!data.cPhone) {
      errors.cPhone = 'Mobile number is Required';
      errors.cPhoneError = true;
      scrollViews.push(this.cPhoneRef);
    } else if (data.cPhone.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.cPhone = 'Please enter at least 10 digit';
      errors.cPhoneError = true;
      scrollViews.push(this.cPhoneRef);
    }
    const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    if (!re.test(data.cPassword)) {
      this.setState({ cpasswordColor: 'red' });
      errors.cPasswordError = true;
      scrollViews.push(this.cPassword);
    }


    if (!data.cEmployer) {
      errors.cEmployer = 'Employer name is Required';
      errors.cEmployerError = true;
      scrollViews.push(this.cEmployerRef);
    } else if (data.cEmployer.length < 2) {
      errors.cEmployer = 'Please enter at least 2 characters';
      errors.cEmployerError = true;
      scrollViews.push(this.cEmployerRef);
    }


    if (!data.cSince) {
      errors.cSince = 'Since is Required';
      errors.cSinceError = true;
      scrollViews.push(this.cSinceRef);
    }

    if (!data.cState) {
      errors.cState = 'State is Required';
      errors.cStateError = true;
      scrollViews.push(this.cStateRef);
    }
    if (scrollViews.length > 0) {
      scrollToComponent(scrollViews[0], {
        offset: 200, align: 'bottom', duration: 500, ease: 'inExpo',
      });
    }


    return {
      errors,
      isValidConsumer: isEmpty(errors),
    };
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  async handleSubmitConsumer(e) {
    e.preventDefault();
    const { cFirstName, cLastName } = this.state;
    const { history, handlerFromParant } = this.props;

    if (this.isValidConsumer()) {
      // localStorage.setItem('consumerTab', '2');
      // this.props.handlerFromParant(2);
      this.setState({
        errors: {},
        defaultIndex: handlerFromParant,
        signatureDefaultValue: `${cFirstName} ${cLastName}`,
      }, async () => {
        await this.props.saveBusinessUserStep1(this.state);
        await history.push({ pathname: '/signup-terms-condition' });
      });


      // if (this.props.partnerType === 'Consumer') {
      //   this.setState({ errors: {}, IsConusmerForm: 2 });
      // } else {
      //   this.setState({ errors: {}, IsConusmerForm: 2 });
      // }
      // scrollToComponent(this.termsAndConditionsRef, { offset: 0, align: 'bottom', duration: 500, ease: 'inExpo' })

      // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
      // this.setState({ signatureDefaultValue: `${cFirstName} ${cLastName}` });
    }
  }

  AckOnchange(e) {
    const name = e.target.name;
    let value = '0';
    if (name === 'cNotification' && e.target.checked === true) {
      value = '1';
    }
    if (name === 'bankAccount' && e.target.checked === true) {
      value = '1';
    }
    if (name === 'serviceFeeAgree' && e.target.checked === true) {
      value = '1';
    }
    if (name === 'cUpdateClaim' && e.target.checked === true) {
      value = '1';
    }
    this.setState({
      [e.target.name]: value, errorsTermPolicy: {}, errors: {}, cpasswordColor: 'black',
    });
  }

  onChange1(e) {
    this.setState({ passwordColor: 'black' });
    //  const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    //  if (re.test(e.target.value) || e.target.value === '') {
    this.setState({
      [e.target.name]: e.target.value.trimLeft(), errors: {}, errorsTermPolicy: {}, cpasswordColor: 'black',
    });
    //  }
  }

  openModal() {
    this.setState({ modalIsOpen: true, errors: {} });
  }

  viewPassword() {
    if (this.state.passwordType === 'password') {
      this.setState({ passwordType: 'text' });
    } else {
      this.setState({ passwordType: 'password' });
    }
  }

  afterOpenModal() {
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  fileChangedHandler = (event) => {
    this.setState({ file: event.target.files[0] });
  }

  uploadHandler = () => {
  }

  confirmState() {
    this.setState({ errors: {}, IsConusmerForm: 4 });
  }

  codeOnSubmit(e) {
    e.preventDefault();
    if (this.state.code !== '') {
      this.props.confirmUserEmail(this.state);
    } else {
      const errors = {};
      errors.code = 'Verification code is Required';
      this.setState({
        errors,
      });
    }
  }

  componentDidUpdate() {
    const { userDataLogin, BusinessUserDataStep1Data, caffiliateIdData } = this.state;
    const { userInfo } = this.props.data;
    const { signupData: { BusinessUserDataStep1 }, affiliateId } = this.props;

    if (caffiliateIdData !== affiliateId) {
      this.setState({
        caffiliateId: affiliateId,
        caffiliateIdData: affiliateId,
      });
    }

    if (BusinessUserDataStep1.step1 !== undefined) {
      if (BusinessUserDataStep1Data !== BusinessUserDataStep1) {
        // console.log('dddddddddddddddddddddddddddd',BusinessUserDataStep1.step1.affiliateId)
        this.setState({
          BusinessUserDataStep1Data: BusinessUserDataStep1,
          cFirstName: BusinessUserDataStep1.step1.cFirstName,
          cLastName: BusinessUserDataStep1.step1.cLastName,
          cState: BusinessUserDataStep1.step1.cState,
          cSince: BusinessUserDataStep1.step1.cSince,
          cEmployer: BusinessUserDataStep1.step1.cEmployer,
          cEmail: BusinessUserDataStep1.step1.cEmail,
          cPhone: BusinessUserDataStep1.step1.cPhone,
          cPassword: BusinessUserDataStep1.step1.cPassword,
          cNotification: BusinessUserDataStep1.step1.cNotification,
          cUpdateClaim: BusinessUserDataStep1.step1.cUpdateClaim,
          cRoleName: BusinessUserDataStep1.step1.cRoleName,
          roleName: BusinessUserDataStep1.step1.roleName,
          serviceFeeAgree: BusinessUserDataStep1.step1.serviceFeeAgree,
          bankAccount: BusinessUserDataStep1.step1.bankAccount,
          firstName: BusinessUserDataStep1.step1.firstName,
          lastName: BusinessUserDataStep1.step1.lastName,
          signatureDefaultValue: BusinessUserDataStep1.step1.signatureDefaultValue,
          companyTitle: BusinessUserDataStep1.step1.companyTitle,
          email: BusinessUserDataStep1.step1.email,
          password: BusinessUserDataStep1.step1.password,
          workPhoneNumber: BusinessUserDataStep1.step1.workPhoneNumber,
          nonWorkPhoneNumber: BusinessUserDataStep1.step1.nonWorkPhoneNumber,
          companyName: BusinessUserDataStep1.step1.companyName,
          acceptCC: BusinessUserDataStep1.step1.acceptCC,
          bankruptcyStatus: BusinessUserDataStep1.step1.bankruptcyStatus,
          dissolvedStatus: BusinessUserDataStep1.step1.dissolvedStatus,
          totalTaxId: BusinessUserDataStep1.step1.totalTaxId,
          streeAddress: BusinessUserDataStep1.step1.streeAddress,
          city: BusinessUserDataStep1.step1.city,
          state: BusinessUserDataStep1.step1.state,
          zipCode: BusinessUserDataStep1.step1.zipCode,
          separateTaxId: BusinessUserDataStep1.step1.separateTaxId,
          enterpriseType: BusinessUserDataStep1.step1.enterpriseType,
          startingYear: BusinessUserDataStep1.step1.startingYear,
          webSite: BusinessUserDataStep1.step1.webSite,
          industryTypeId: BusinessUserDataStep1.step1.industryTypeId,
          taxId: BusinessUserDataStep1.step1.taxId,
          planPriceId: BusinessUserDataStep1.step1.planPriceId,
          readDisclaimer: BusinessUserDataStep1.step1.readDisclaimer,
          readPrivacyPolicy: BusinessUserDataStep1.step1.readPrivacyPolicy,
          readLetterOfAgency: BusinessUserDataStep1.step1.readLetterOfAgency,
          readUserAgreement: BusinessUserDataStep1.step1.readUserAgreement,
          defaultIndex: BusinessUserDataStep1.step1.defaultIndex,

          affiliateKeyId: BusinessUserDataStep1.step1.affiliateKeyId,
          affiliateId: BusinessUserDataStep1.step1.affiliateId,

          caffiliateId: BusinessUserDataStep1.step1.caffiliateId,
          caffiliateKey: BusinessUserDataStep1.step1.caffiliateKey,

          selectedPlanName: BusinessUserDataStep1.step1.selectedPlanName,
          selectedPlanAmount: BusinessUserDataStep1.step1.selectedPlanAmount,

        });
      }
    }

    if (typeof userInfo.user !== 'undefined') {
      if (userDataLogin !== userInfo) {
        this.setState({
          userDataLogin: userInfo,
        });
        this.context.router.history.push('/dashboard');
      }
    }
  }

  AfterLogin() {
    if (!this.state.isLoginCheck) {
      Auth.signIn(this.state.cEmail.toLowerCase(), this.state.cPassword).then((user) => {
        const jwtToken = user.signInUserSession.accessToken.jwtToken;
        const postInfo = {
          email: this.state.cEmail.toLowerCase(),
          token: jwtToken,
          user,
        };
        this.props.requestApiData(postInfo);
        this.setState({ isLoginCheck: true });
        // setTimeout(() => { ; }, 1000);
      }).catch((error) => {
        this.setState({ isLoginCheck: false, isLoading: false });
        this.setState({ failedLoginMessages: error.message });
        // if (error.message === 'User is not confirmed.') {
        //   this.context.router.history.push('/verify-code');
        // }
      });
    }
  }

  render() {
    const {
      errors, enableButtonT, caffiliateId, pageType, cCountryCode, cpasswordColor, cPhone, cEmployer, code, cSince, cEmail, cPassword, passwordType, cFirstName, cLastName, IsConusmerForm, signatureDefaultValue, signatureFontFamily, isLoading,
    } = this.state;
    const {
      AllStates, AllCountryData, ConfirmUserEmailData, affilateUserList
    } = this.props.data;
    let errorForcodeverify = false;
    if (ConfirmUserEmailData.code !== 'undefined ' && ConfirmUserEmailData.code === 200) {
      this.AfterLogin();
    }
    if (ConfirmUserEmailData.code !== 'undefined ' && ConfirmUserEmailData.code === 400) {
      errorForcodeverify = true;
    }
    // adding state for dropdown
    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: cCountryCode });
    const cDefaultOptionCountry = cSelectedCountry;


    const options = [];
    options.push(<option selected disabled key={0} value="">State</option>);
    AllStates.map(item =>
      // return options.push({value: item.stateId, label: item.stateName, name: item.stateName})
      options.push(<option key={item.stateId} value={item.stateId}>{item.stateName}</option>));

    const optionsSince = [];
    optionsSince.push({ value: '', label: 'Since', name: 'Since' });

    const currentDate = new Date().getFullYear();
    optionsSince.push({ value: 1989, label: 'Prior to 1990', name: 'Prior to 1990' });
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({ value: i, label: i, name: i });
    }

    // selecting the first index to select
    const cSelectedSince = _.find(optionsSince, { value: cSince });
    const cDefaultSince = cSelectedSince;

    const infoDataConsumer = [];
    const infoDataBar = [];

    const affilateUserListOption = [];
    affilateUserListOption.push({ value: '', label: 'Select Partner', name: 'Select Partner' });
    if (affilateUserList) {
      affilateUserList.map(item => affilateUserListOption.push({
        value: item.userId,
        label: item.fullName,
        name: item.fullName,
      }));
    }

    const selectedAffilate = _.find(affilateUserListOption, { value: caffiliateId });
    const defaultOptionAffilate = selectedAffilate;



    return (
      <span>
        <form onSubmit={this.handleSubmitConsumer} className={IsConusmerForm === 1 ? 'show ' : 'hide'}>
          <div className="row">
            <div className="div-full personal-info-spacing">
              <h6 className="tab-heading">Personal Information</h6>
              <div className="col s12 m12">
                <div className="input-field col s12" ref={(section) => { this.cFirstNameRef = section; }}>
                  <TextFieldGroup
                    field="cFirstName"
                    label="First name*"
                    value={cFirstName}
                    error={errors.cFirstName}
                    onChange={this.onChange1}
                  />
                </div>
                <div className="input-field col s12" ref={(section) => { this.cLastNameRef = section; }}>
                  <TextFieldGroup
                    field="cLastName"
                    label="Last name*"
                    value={cLastName}
                    error={errors.cLastName}
                    onChange={this.onChange1}
                  />

                </div>
                <div className="row phone-signupnew">
                  <div className="input-field tel-input-lt">
                    <label className="active">Country Code</label>
                    <Dropdown
                      name="cState"
                      className="browser-default"
                      options={optionsCountry}
                      onChange={this._cCountrySelect}
                      value={cDefaultOptionCountry}
                      placeholder="Select an option"
                    />
                  </div>
                  <div className="input-field tel-input-rt" ref={(section) => { this.newMobilePhoneRef = section; }}>

                    <MaskInputNumber
                      field="cPhone"
                      label="Phone*"
                      value={cPhone}
                      error={errors.cPhone}
                      onChange={this.onChange}
                    />

                  </div>
                </div>


                {/* <div className="row phone-signupnew">
                    <div className="input-field col s12 col m5" style={{ paddingLeft: 0 }}>
                      <label className="active">Country Code</label>
                      <Dropdown
                        name="cState"
                        className="browser-default"
                        options={optionsCountry}
                        onChange={this._cCountrySelect}
                        value={cDefaultOptionCountry}
                        placeholder="Select an option"
                      />
                    </div>
                    <div className="input-field col s12 m7" style={{ paddingLeft: 0 }} ref={(section) => { this.cPhoneRef = section; }}>

                      <MaskInputNumber
                        field="cPhone"
                        label="Phone*"
                        value={cPhone}
                        error={errors.cPhone}
                        onChange={this.onChange}
                      />

                    </div>
                  </div> */}
                <div className="col s12">
                  <label>
                    <input type="checkbox" name="cUpdateClaim" checked={this.state.cUpdateClaim === '1'} onChange={this.AckOnchange} value="1" />
                    {/* <input type="checkbox" name="serviceFeeAgree" onChange={this.AckOnchange} value="1" checked={this.state.serviceFeeAgree === '1'} /> */}

                    <span>Send me text updates about my claims (note that your wireless provider may charge additional fees for these text messages)</span>
                    <span className={errors.cUpdateClaimError ? 'show invalid' : 'hide'}>
                      {errors.cUpdateClaim}
                    </span>
                  </label>
                </div>


                <div className="col s12 custom-select" ref={(section) => { this.cStateRef = section; }}>
                  <label className="active font-scale">State*</label>
                  <select value={this.state.cState} name="cState" onChange={this._cSelect}>
                    {(typeof options !== 'undefined') ? (options) : ''}
                  </select>

                  <span
                    className={errors.cStateError ? 'show invalid' : 'hide'}
                  >
                    {errors.cState}

                  </span>
                </div>

                <div className="input-field col s12" ref={(section) => { this.cSinceRef = section; }}>
                  <label className="xs-small active">Since*</label>
                  <Dropdown
                    name="cState"
                    className="browser-default"
                    options={optionsSince}
                    onChange={this._cSince}
                    value={cDefaultSince}
                    placeholder="Select an option"
                  />
                  <span className="question-signup1 q-icon">
                    <Tooltip id="tooltip-icon" title="Please tell us when did you move to your current state">
                      <i className="xs-small material-icons">help</i>
                    </Tooltip>
                  </span>
                  <span
                    className={errors.cSinceError ? 'show invalid' : 'hide'}
                  >
                    {errors.cSince}

                  </span>
                </div>


                <div className="input-field col s12" ref={(section) => { this.cEmployerRef = section; }}>

                  <div className="q-rt employer-question">
                    <TextFieldGroup
                      field="cEmployer"
                      label="Employer*"
                      value={cEmployer}
                      error={errors.cEmployer}
                      onChange={this.onChange}
                    />
                    <span className="question-signup2 q-icon">
                      <Tooltip id="tooltip-icon" title="If your current employer is a defendant in a specific class action, we wont share any settlement of that class action with you, although you may otherwise be eligible.">
                        <i className="xs-small material-icons">help</i>
                      </Tooltip>
                    </span>
                  </div>
                </div>

                <div className="input-field col s12" ref={(section) => { this.cEmailRef = section; }}>
                  <TextFieldGroup
                    field="cEmail"
                    label="Email*"
                    value={cEmail}
                    error={errors.cEmail}
                    // checkUserExists={this.verifyEmail}
                    onChange={this.onChange}
                  />
                </div>
                <div className="input-field col s12" ref={(section) => { this.cPassword = section; }}>
                  <div className="q-rt employer-question">
                    <TextFieldGroup
                      field="cPassword"
                      label="Password*"
                      value={cPassword}
                      error={errors.cPassword}
                      onChange={this.onChange}
                      type={passwordType}
                    />

                  </div>
                  <span className="question-signup q-icon">
                    <a onClick={this.viewPassword}>
                      {' '}
                      <i className="small material-icons">visibility</i>
                    </a>
                  </span>
                  <span className="invalid invalid-password" style={{ color: cpasswordColor }}>Password Requirements – minimum of 8 characters, 1 capital letter, 1 lower case letter, 1 special character, 1 number.</span>

                </div>

                <div className="input-field col s12">
                  <Dropdown
                    className="browser-default"
                    options={affilateUserListOption}
                    onChange={this._onSelectForPartner}
                    value={defaultOptionAffilate}
                    placeholder="Select an option*"
                  />
                </div>

                <div className="col s12 check-box-header">Check the boxes below to continue</div>
                <div className="col s12" ref={(section) => { this.bankAccountErrorRef = section; }}>

                  <label>
                    <input type="checkbox" name="cNotification" onChange={this.AckOnchange} value="1" checked={this.state.cNotification === '1'} />
                    <span>I agree that you may notify me of product updates by email.</span>
                    <span className={errors.cNotificationError ? 'show invalid check-validation' : 'hide'}>
                      {errors.cNotification}
                    </span>
                  </label>
                </div>
                <div className="col s12">
                  <label>
                    <input type="checkbox" name="bankAccount" onChange={this.AckOnchange} value="1" checked={this.state.bankAccount === '1'} />
                    <span> For Collectively to transfer settlement funds to me, I understand that I must have a U.S. bank or investment account that complies with applicable laws and regulations. Collectively only transfers funds electronically—checks will not be issued.</span>
                    <span className={errors.bankAccountError ? 'show invalid check-validation' : 'hide'}>
                      {errors.bankAccount}
                    </span>
                  </label>
                </div>
                <div className="col s12" ref={(section) => { this.serviceFeeAgreeErrorRef = section; }}>
                  <label>
                    <input type="checkbox" name="serviceFeeAgree" onChange={this.AckOnchange} value="1" checked={this.state.serviceFeeAgree === '1'} />
                    <span> I understand that Collectively will withold a service fee of 19.95% from the proceeds of any successful claim.</span>
                    <span className={errors.serviceFeeAgreeError ? 'show invalid check-validation' : 'hide'}>
                      {errors.serviceFeeAgree}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className="col s12 ">
              <div className="divider hdr-bdr " />
            </div>
            <div className="col s12 back-signupbutton">

              <button
                className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 tab-btn"
                type="submit"
                name="action"
              >
                Next
                  <i className="material-icons">arrow_forward</i>
              </button>
            </div>


          </div>


        </form>

        <div className={IsConusmerForm === 5 ? 'section-content settlement' : 'hide'}>
          <div className="row">
            <div className="col s10 offset-s1">
              <div className="row">
                <h4 className="col s12 plan-hdr-outer center-align">Settlement Monitoring</h4>
                {infoDataConsumer}
                {infoDataBar}
                <div className="col s12 back-signupbutton">
                  <a className="btn waves-effect waves-light primary-btn col s6 offset-s3" onClick={this.backClick}>
                    <i className="material-icons">arrow_backward</i>
                    Back
                    </a>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className={IsConusmerForm === 2 ? 'section-content left-align term-condition' : 'hide'}>
          <div className="row">
            <div className="col s12 m12">
              <div className="row" ref={(section) => { this.termsAndConditionsRef = section; }}>
                <div className="col s12">
                  <h4>Collectively monitors, files and helps you collect from antitrust and class action settlements. In order for us to be able to act on your behalf, we need you to agree to the following</h4>
                </div>
              </div>

              <div className="row">
                <TermAndCondition
                  termsAndConditionData={this.handleSaveData}
                  termsAndConditionBack={this.backClick}
                  pageType={pageType}
                  backButton={enableButtonT}
                />

              </div>

            </div>
          </div>
        </div>
        <div ref={(section) => { this.signatureRef = section; }} className={IsConusmerForm === 3 ? 'section-content left-align create-signature' : 'hide'}>
          <SignatureComponent
            defaultValue={signatureDefaultValue}
            fontFamily={signatureFontFamily}
            signBack={this.backClick}
            finalSubmitData={this.finalSubmit}
            loader={isLoading}
            hide
          />
        </div>
        <div className={IsConusmerForm === 4 ? 'section-content center-align login-content' : 'hide'}>
          <h2>Confirm Account</h2>
          <p>An activation code has been emailed to you. Please enter it below and submit to continue.</p>

          <div className="row">
            <form className="col s8 offset-s2" onSubmit={this.codeOnSubmit}>
              <div className="row">
                <div className="input-field col s12">
                  <TextFieldGroup
                    field="code"
                    label="Code"
                    value={code}
                    error={errors.code}
                    onChange={this.onChange}
                  />
                </div>
                <span className={errorForcodeverify ? 'show invalid' : 'hide'}>code is not valid.</span>
                <div className="col s12">
                  <button className="btn waves-effect waves-light primary-btn col s12 signup-consumer-confirm-btn " type="submit" name="action">
                    Confirm
                      <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>

      </span>
    );
  }
}
Signup.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  data: state.data,
  signupData: state.signupData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getPageData, saveConsumerUser, GetAllAffiliateUsersByAffiliateType, saveBusinessUserStep1, checkEmailVerify, getAllCountry, getAllStates, getAllPlansConsumer, confirmUserEmail, getIndustry, getBusiness, requestApiData,
  }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));
